import styled from 'styled-components';
import { Modal } from 'antd';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    overflow: hidden;
    background: transparent;
    box-shadow: none;
  }

  .ant-modal-close {
    top: 1%;
    right: 1%;
    color: black;
    background: rgb(255 255 255 / 90%);

    &:hover {
      background: rgb(255 255 255 / 90%);
    }
  }
`;
